export class AmGroup {
  constructor(group) {
    group = group || {};
    this.id = group.id;
    this.name = group.name;
    this.assets = group.assets;
    this.email = group.email;
    this.createdAt = group.createdAt;
    this.attrs = group.attrs;
    this.tags = group.tags;
  }
}
